import { render, staticRenderFns } from "./Bigmenu.vue?vue&type=template&id=05318a11&scoped=true"
import script from "./Bigmenu.vue?vue&type=script&lang=js"
export * from "./Bigmenu.vue?vue&type=script&lang=js"
import style0 from "./Bigmenu.vue?vue&type=style&index=0&id=05318a11&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05318a11",
  null
  
)

export default component.exports